import { render, staticRenderFns } from "./fireAlarm.vue?vue&type=template&id=ab801922&scoped=true&"
import script from "./fireAlarm.vue?vue&type=script&lang=js&"
export * from "./fireAlarm.vue?vue&type=script&lang=js&"
import style0 from "./fireAlarm.vue?vue&type=style&index=0&id=ab801922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab801922",
  null
  
)

export default component.exports